export default {"src":"/_next/static/media/customer-data.72a0dd75.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};